import { IdentifierDTO } from '@zazume/zzm-base';

import { UserBankPaymentInitialization } from '#/models/bank/UserBankPaymentInitialization';

import { doGet } from '../../helpers';

export const bankPayments = {
  public: {
    getInitializationParams: (bankPaymentId: IdentifierDTO, token: string) => () =>
      doGet<UserBankPaymentInitialization>(`/public/web/bank-payments/initialization/${bankPaymentId}?token=${token}`)
  }
};
